"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
require("./InterstitialScreen.css");
var _FormulaParser = _interopRequireDefault(require("../../../utility/Forms/FormulaParser"));
var _material = require("@mui/material");
var _FlatButton = _interopRequireDefault(require("../FlatButton/FlatButton"));
var _SlideDirection = require("../../../utility/Forms/SlideDirection");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var InterstitialScreen = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  var _props$theme, _props$theme2;
  var _useState = (0, _react.useState)(props.slideDirection),
    _useState2 = _slicedToArray(_useState, 2),
    slideDirection = _useState2[0],
    setSlideDirection = _useState2[1];
  var _useState3 = (0, _react.useState)(props.answers),
    _useState4 = _slicedToArray(_useState3, 2),
    answers = _useState4[0],
    setAnswers = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    wasFormSubmitted = _useState6[0],
    setWasFormSubmitted = _useState6[1];
  var _useState7 = (0, _react.useState)(props.loading),
    _useState8 = _slicedToArray(_useState7, 2),
    showLoadingIndicator = _useState8[0],
    setShowLoadingIndicator = _useState8[1];
  var interpolationRegex = /[^{\}]+(?=})/g;
  (0, _react.useEffect)(function () {
    setSlideDirection(props.slideDirection);
    setAnswers(props.answers);
    setWasFormSubmitted(props.wasFormSubmitted);
    setShowLoadingIndicator(props.loading);
  }, [props.answers, props.slideDirection, props.wasFormSubmitted, props.loading]);
  function getHeading() {
    if (props.isEndScreen) {
      if (!wasFormSubmitted) {
        return "All Done!";
      } else {
        return "👍";
      }
    }
    return props.data.heading;
  }
  function getPrompt() {
    if (props.isEndScreen) {
      if (!wasFormSubmitted) {
        return props.endScreenPrompt;
      } else {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: ["Thanks for filling out this form! Create your own form with ", /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
              href: "https://parlanceform.com",
              children: "ParlanceForm"
            })
          }), "."]
        });
      }
    } else if (props.data.prompt.trim().startsWith("=")) {
      return _FormulaParser.default.executeFormula(props.data.prompt, props.answers);
    }
    return interpolate(props.data.prompt);
  }
  function replaceWithValue(variableName, entireString) {
    var keyToReplace = "{" + variableName + "}";
    var valueToReplace = props.answers[variableName];
    if (!valueToReplace) {
      return entireString;
    }
    return entireString.replaceAll(keyToReplace, valueToReplace);
  }
  function interpolate(text) {
    if (!text) {
      return text;
    }
    var interpolatedText = text;
    var matches = text.match(interpolationRegex);
    if (!matches) {
      return text;
    }
    var _iterator = _createForOfIteratorHelper(matches),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var match = _step.value;
        interpolatedText = replaceWithValue(match, interpolatedText);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return interpolatedText;
  }
  function handleSubmitClick() {
    if (props.isEndScreen) {
      if (!wasFormSubmitted) {
        props.submitForm();
      } else {
        window.location = "https://datagrown.com";
      }
    } else {
      props.setAnswer(props.data.id, null, true);
    }
  }
  function getButtonLabel() {
    if (props.isEndScreen) {
      if (!wasFormSubmitted) {
        return "Submit";
      } else {
        return "Become data driven";
      }
    } else {
      return props.data.buttonPrompt || "Let's go";
    }
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ref: forwardedRef,
    className: "full-screen-question section-intro-screen ".concat(slideDirection === _SlideDirection.SlideDirection.Up ? "slide-up-from-bottom" : "slide-down-from-top", " ").concat(props.isEndScreen ? "appear" : ""),
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "question-content",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
        style: ((_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.h1) || null,
        children: getHeading()
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        children: getPrompt()
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FlatButton.default, {
        variant: "contained",
        disableElevation: true,
        disabled: showLoadingIndicator,
        sx: (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.button,
        onClick: function onClick() {
          return handleSubmitClick();
        },
        children: [showLoadingIndicator ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.CircularProgress, {
          size: 18
        }) : null, getButtonLabel()]
      })]
    })
  });
});
var _default = InterstitialScreen;
exports.default = _default;